import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/userContext";
import { useDataParams } from "hooks/DataParamsHook";
import Loader from "components/LoaderComponent";

export const PrivateGuard = () => {
  const { user, loading } = useAuth();
  const { loading: loadingParams } = useDataParams();

  if(loading || loadingParams) {
    return <Loader />;
  }

  if(!user) {
    return <Navigate to={"/login"} />;
  }

 
  return <Outlet />

};
